// Sidebar reducer

import { UPDATE_STEP } from "./action";
import { RESET_APPS } from "@store/actions";

const defaultState = {
  stepsMeta: {
    activeStep: 0,
    activeSubStep: 0,
    totalParentSteps: 1 // only one parentStep for right now
  }
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case UPDATE_STEP:
      return {
        ...state,
        stepsMeta: {
          ...state.stepsMeta,
          activeStep: action.activeStep,
          activeSubStep: action.activeSubStep
        }
      };
    case RESET_APPS:
      return {
        ...defaultState
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pretravel/components/Sidebar/reducer.js